import React from 'react'
import { BillingContentTitle } from '../Shared/UI/Components/BillingContentTitle'

const PricePlans = () => {
  return <BillingContentTitle>Your current price plan details</BillingContentTitle>
}

export default PricePlans
